/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import statusTokens, { resolveStatusVariant } from "styles/tokens/status";
import { formatEnumLabel } from "./formatters";

/**
 * Status pill from the semantic status tokens. `variants` maps a domain status
 * (HELD, SPA_SIGNED, ...) to a token variant (success/warning/info/error/
 * neutral) where the shared alias table does not already know it.
 */
const EntityStatusChip = ({ status, variants, label, size }) => {
  if (status === null || status === undefined || status === "") return <span>-</span>;
  const key = String(status).toUpperCase();
  const variant = (variants && variants[key]) || resolveStatusVariant(status);
  const tokens = statusTokens[variant] || statusTokens.neutral;
  const small = size === "xs";
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: small ? 1.25 : 1.5,
        py: small ? 0.35 : 0.5,
        bgcolor: tokens.background,
        color: tokens.text,
        borderRadius: 999,
        fontSize: small ? "0.6875rem" : "0.75rem",
        fontWeight: 600,
        letterSpacing: "0.02em",
        lineHeight: 1.2,
        whiteSpace: "nowrap",
      }}
    >
      <Box component="span" sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: tokens.dot }} />
      {label ?? formatEnumLabel(status)}
    </Box>
  );
};

EntityStatusChip.propTypes = {
  status: PropTypes.string,
  variants: PropTypes.object,
  label: PropTypes.string,
  size: PropTypes.oneOf(["xs", "sm"]),
};

EntityStatusChip.defaultProps = {
  status: null,
  variants: null,
  label: undefined,
  size: "sm",
};

export default EntityStatusChip;
